<template>
  <div class="container-fluid">
    <net-pa-card v-if="Level < 3">
      <template v-slot:header>
        <h6 v-if="Level != 1 && Level != 2" class="text-right"><i class="fas fa-cheque ml-2"></i>لیست امضاهای ثبت شده</h6>
        <h6 v-else class="text-right"><i class="fas fa-cheque ml-2"></i>ثبت امضا</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div v-if="Level == 0" class="col-12">
            <sign-list @introduceNew="OpenLevel1()" @CompeleteSign="OpenLevel2" @SafteRecieve="OpenLevel3" @ListSafte="OpenLevel5"></sign-list>
          </div>
          <div v-if="Level == 1" class="col-12">
            <Introduce-signature @introduce_success="succesIntroduce"></Introduce-signature>
          </div>
          <div v-if="Level == 2" class="col-12">
            <create-sign @click="Level = 0" @create_success="Level = 0" :IntroduceInfo="IntroduceInfo"></create-sign>
          </div>
          <div v-if="Level != 0" class="col-3 p-2 mr-4">
            <button @click="Level = 0" class="btn btn-danger w-100">انصراف</button>
          </div>
        </div>
      </template>
    </net-pa-card>
    <net-pa-card v-if="Level != 1 && Level != 2">
      <template v-slot:header>
        <h6 class="text-right"><i class="fas fa-cheque ml-2"></i>لیست سفته ها</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div v-if="Level == 3" class="col-12">
            <SafteReceive @SafteRecieved="OPenLevel0"></SafteReceive>
          </div>
          <div v-if="Level == 0" class="col-12">
            <safte-list :key="safteListKey" @SignF="OpenLevel6" @NewSafte="OpenLevel3" :Sign="Sign"></safte-list>
          </div>
          <div v-if="Level == 6" class="col-12">
            <sign-Finally @SignDone="DoneSigning" :SafteToSign="SafteToSign"></sign-Finally>
          </div>
          <div v-if="Level != 0" class="col-3 p-2 mr-4">
            <button @click="Level = 0" class="btn btn-danger w-100">انصراف</button>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from '../../Tools/NetPa/NetPaCard.vue'
import CreateSign from './CreateSign.vue'
import IntroduceSignature from './IntroduceSignature.vue'
import SafteList from './SafteList.vue'
import SafteReceive from './Safte_Receive.vue'
import SignList from './SignList.vue'
import SignFinally from './SignFinally.vue'
export default {
  components: { NetPaCard, IntroduceSignature, CreateSign, SignList, SafteReceive, SafteList, SignFinally },
  data() {
    return {
      SafteToSign: null,
      Level: 0,
      IntroduceInfo: {},
      SafteReceiveData: {},
      Sign: {},
      safteListKey: 0,
    }
  },
  methods: {
    succesIntroduce(data) {
      this.Level++
      console.warn(data)
      this.IntroduceInfo = data
    },
    OPenLevel0() {
      this.Level = 0
    },
    OpenLevel1() {
      this.Level = 1
    },
    OpenLevel2(sign) {
      this.IntroduceInfo = {
        national_code: sign.national_code,
        ref_id: sign.request_id,
        fa_first_name: sign.fa_first_name,
        fa_last_name: sign.fa_last_name,
        request_id: sign.request_id,
      }
      this.Level = 2
    },
    OpenLevel3(sign) {
      this.Level = 3
      this.SafteReceiveData = sign
    },
    OpenLevel5() {
      this.Level = 5
    },
    OpenLevel5(sign) {
      this.Level = 5
      this.Sign = sign
      console.warn(this.Sign)
    },
    OpenLevel6(sign) {
      this.Level = 6
      this.SafteToSign = sign
    },
    DoneSigning() {
      this.Level = 0
      this.safteListKey++
    },
  },
  created() {},
}
</script>
